export const BANNER_PLATE = 'aspect-[54/13]';

export const BANNER_ASPECT = 54 / 13;

export const BANNER_PIXELS = '2160 x 520';
